export default __webpack_public_path__ + "static/media/bx-home-circle.6d3a0b99.svg";